import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { getAjusteArticulo, saveAjusteArticulo } from "../../services/AjusteArticuloService";
import AjusteArticuloDialog from "./AjusteArticuloDialog";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialAjusteArticulo = {
  codigoArticulo: "",
  fechaRegistracion: format(new Date(), "dd/MM/yyyy"),
  observaciones: "",
  motivoAnulacion: "",
  descripcion: "",
  idTipoAjusteStock: "",
};

const nameItemsText = "Ajuste de artículos";
//
// ##########################################################################
//
const AjusteArticulo = () => {
  const navigate = useNavigate();
  const params = useParams();
  const idAjusteArticulo = params.idAjuste;
  const action = params.action;
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [ajusteArticuloData, setAjusteArticuloData] = useState(initialAjusteArticulo);
  const [ajusteArticuloItems, setAjusteArticuloItems] = useState([]);
  const [ajusteArticuloEstadoRows, setAjusteArticuloEstadoRows] = useState([]);
  const [ajusteArticuloItem, setAjusteArticuloItem] = useState({});
  const [openAjusteArticuloDialog, setOpenAjusteArticuloDialog] = useState(false);
  const [actionCrud, setActionCrud] = useState("");
  const [actionTitle, setActionTitle] = useState("");

  const tableColumns = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      width: 120,
      sortable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "descripcion_articulo",
      headerName: "Descripción",
      headerAlign: "center",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tipo_ajuste_stock",
      headerName: "Tipo de ajuste",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tipo_ajuste_stock;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      width: 120,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        let _val = params.row.cantidad;
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver artículo">
            <IconButton
              size="small"
              aria-label="view"
              onClick={() => handleClickActionCrud(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>

          {(action === "new" || action === "update") && (
            <>
              <Tooltip title="editar artículo">
                <IconButton
                  size="small"
                  aria-label="edit"
                  onClick={() => handleClickActionCrud(params.row, "update")}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="eliminar artículo">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickActionCrud(params.row, "delete")}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      ),
    },
  ];

  const tableColumnsEstado = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      maxWidth: 200,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        switch (_val) {
          case 'activo':
            _val = "ACTIVO";
            break;
          case 'anulado':
            _val = "ANULADO";
            break;
          default:
            _val = "ERROR";
        }
        return _val;
      },
    },
    {
      field: "ultimo_estado",
      headerName: "Estado actual?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ultimo_estado ? "SÍ" : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "username",
      headerName: "Operador",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "motivo",
      headerName: "Motivo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.motivo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id_articulo || row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {

    if (action === "view") {
      setActionTitle("Ver");
    } else if (action === "update") {
      setActionTitle("Editar");
    } else if (action === "new") {
      setActionTitle("Nuevo");
    } else if (action === "delete") {
      setActionTitle("Anular");
    }

    if (action !== "new") {
      load();
    }
  }, []);
  //
  // ##########################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getAjusteArticulo(idAjusteArticulo);
    setIsDoingSomething(false);

    if (response.ok) {

      const _ajusteArticuloData = response.data.data;

      setAjusteArticuloData({
        ...ajusteArticuloData,
        codigoAjuste: _ajusteArticuloData.codigo,
        fechaRegistracion: _ajusteArticuloData.fecha_creacion,
        descripcion: _ajusteArticuloData.descripcion,
        observaciones: _ajusteArticuloData.observaciones,
      });

      setAjusteArticuloItems(response.data.data.ajuste_articulo_list);

      const _ajuste_estado_list = _ajusteArticuloData.ajuste_estado_list;

      if (action === "view") {
        setAjusteArticuloEstadoRows(_ajuste_estado_list);
      }
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################  
  //
  const handleCancelar = () => {
    navigate("/ajuste-articulo-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    setAjusteArticuloData({
      ...ajusteArticuloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleCloseAjusteArticuloDialog = () => {
    setOpenAjusteArticuloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleClickActionCrud = async (parAjusteArticuloItem, parAction) => {
    setActionCrud(parAction);
    setAjusteArticuloItem(parAjusteArticuloItem);
    setOpenAjusteArticuloDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleOnSave = (parItemCrud, parAction) => {
    let _ajusteArticuloItems = [...ajusteArticuloItems];

    if (parAction !== "delete") {
      let _existe = false;

      _ajusteArticuloItems.forEach((item) => {
        if (parAction === "new" ? true : item.id !== parItemCrud.id) {
          if (parItemCrud.codigo_articulo === item.codigo_articulo) {
            _existe = true;
          }
        }
      });

      if (_existe) {
        setMessage({
          messageText: "El artículo ya ha sido registrado",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (parAction === "new") {
        _ajusteArticuloItems.push(parItemCrud);
      } else {
        _ajusteArticuloItems.splice(
          _ajusteArticuloItems.findIndex(
            (item) => item.codigo_articulo === parItemCrud.codigo_articulo
          ),
          1
        );
        _ajusteArticuloItems.push(parItemCrud);
      }
      setAjusteArticuloItems(_ajusteArticuloItems);
    } else {
      _ajusteArticuloItems.splice(
        _ajusteArticuloItems.findIndex(
          (articulo) => articulo.codigo_articulo === parItemCrud.codigo_articulo
        ),
        1
      );
      setAjusteArticuloItems(_ajusteArticuloItems);
    }
    setOpenAjusteArticuloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleSave = () => {

    if (action === "new" || action === "update") {

      if (!ajusteArticuloData.descripcion) {
        setMessage({
          messageText: "Debes ingresar una descripción",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      if (ajusteArticuloItems.length === 0) {
        setMessage({
          messageText: "Debes agregar al menos un artículo para ajustar",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    } else {

      if (!ajusteArticuloData.motivoAnulacion) {
        setMessage({
          messageText: "Debes ingresar el motivo de la anulación",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }
    }

    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {

    let _ajusteArticuloObject = {};

    if (action === "new" || action === "update") {
      _ajusteArticuloObject = {
        descripcion: ajusteArticuloData.descripcion,
        observaciones: ajusteArticuloData.observaciones,
        ajuste_articulo_list: ajusteArticuloItems.map((item) => ({
          id_articulo: item.id_articulo,
          id_tipo_ajuste_stock: item.id_tipo_ajuste_stock,
          suma_resta: item.suma_resta,
          cantidad: parseInt(item.cantidad),
          descripcion: item.descripcion_ajuste_articulo,
        })),
      };
      if (action === "update") {
        _ajusteArticuloObject.id = idAjusteArticulo;
      }
    } else {
      _ajusteArticuloObject = {
        id: idAjusteArticulo,
        motivo_anulacion: ajusteArticuloData.motivoAnulacion,
      };
    }

    setIsDoingSomething(true);
    const response = await saveAjusteArticulo(action, _ajusteArticuloObject);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        handleCancelar();
      }, 1000);
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  return (
    <>
      <Paper elevation={1} sx={{
        borderStyle: "solid",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        p: 1,
        m: 1,
        maxWidth: "100%"
      }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ m: 1, mb: 3 }}
            >
              <Typography variant="h5" display="block" gutterBottom >
                {actionTitle} {nameItemsText} {ajusteArticuloData.codigoAjuste}
              </Typography>
            </Box>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12} md={12} lg={4}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción de Ajuste"
                variant="outlined"
                size="small"
                name="descripcion"
                value={ajusteArticuloData.descripcion ? ajusteArticuloData.descripcion.toUpperCase() : ""}
                onChange={handleChange}
                disabled={action === "view" || action === "delete"}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={2}>
              <TextField
                id="fechaRegistracion"
                label="Fecha de Registración"
                variant="outlined"
                size="small"
                name="fechaRegistracion"
                value={ajusteArticuloData.fechaRegistracion}
                disabled={true}
              />
            </Grid>
          </Grid>

          {(action === "new" || action === "update") && (
            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", ml: 1, mb: 2 }}
              >
                <Tooltip title="agregar artículo">
                  <Button
                    className="btn-add"
                    variant="contained"
                    onClick={() => handleClickActionCrud({}, "new")}
                    startIcon={<Add />}
                  >
                    Agregar Artículo
                  </Button>
                </Tooltip>
              </Box>
            </Grid>
          )}


          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Artículos
                </Typography>
                <DataGrid
                  rows={ajusteArticuloItems}
                  columns={tableColumns}
                  {...tableOptions}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                inputProps={{
                  autoComplete: "off",
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={ajusteArticuloData.observaciones ? ajusteArticuloData.observaciones.toUpperCase() : ""}
                onChange={handleChange}
                disabled={action === "view" || action === "delete"}
                multiline
                rows={3}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: "80px",
                    minWidth: "400px",
                  },
                }}
              />
            </Grid>

            {(action === "delete") && (
              <Grid item xs={12}>
                <TextField
                  autoFocus
                  sx={{ width: "100%", mb: 1, mt: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="motivoAnulacion"
                  label="Motivo de Anulación"
                  variant="outlined"
                  size="small"
                  name="motivoAnulacion"
                  value={ajusteArticuloData.motivoAnulacion ? ajusteArticuloData.motivoAnulacion.toUpperCase() : ""}
                  onChange={handleChange}
                  disabled={action === "view"}
                />
              </Grid>
            )}
          </Grid>

          {ajusteArticuloEstadoRows.length > 0 && (
            <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
              <Grid item xs={12}>
                <Box>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Estados del Ajuste de Artículos
                  </Typography>
                  <DataGrid
                    rows={ajusteArticuloEstadoRows}
                    columns={tableColumnsEstado}
                    {...tableOptions}
                  />
                </Box>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
            >
              {action !== "view" && (
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={action !== "delete" ? "primary" : "error"}
                  startIcon={
                    action !== "delete" ? (
                      <SaveIcon />
                    ) : (
                      <RemoveCircleOutlineIcon />
                    )
                  }
                >
                  {action !== "delete"
                    ? "Guardar"
                    : "Anular"}
                </Button>
              )}

              <Button
                variant="outlined"
                size="small"
                onClick={handleCancelar}
              >
                {action === "view"
                  ? "Cerrar"
                  : "Cancelar"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper >

      {openAjusteArticuloDialog && (
        <AjusteArticuloDialog
          actionCrud={actionCrud}
          ajusteArticuloItem={ajusteArticuloItem}
          onSave={handleOnSave}
          onClose={handleCloseAjusteArticuloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {
        showMessage && (
          <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
        )
      }

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default AjusteArticulo;
